const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const assign = require('object-assign');
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const InstructorsStore = require('../../stores/InstructorsStore');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const InstructorsPage = createReactClass({
    displayName: 'InstructorsPage',

    getInitialState: function () {
        return {
            currentPageData: [],
            openDeactivateModal: false,
            workingResource: {}
        }
    },

    getOptions: {
        modifiers: {
            include: ['user', 'genres', 'user.groups'],
            filters: {},
            other: {
                show_deleted: true,
                raw: true
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data',
        refresh: 'list'
    },

    resourceActions: new ResourceActions('instructors'),

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        // Merge modifiers with already present ones
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

        this.resourceActions.listResource(this.getOptions);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        this.requestTableData();

        this.changeListener = this._onChange;
        InstructorsStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        InstructorsStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            currentPageData: InstructorsStore.getResourceListData()
        });
    },

    /**
     * @todo the modals can be their own components
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'edit':
                this.props.history.push(`/instructors/${resource.id}`);
                break;
            case 'create':
                this.props.history.push(`/instructors/`);
                break;
            case 'deactivate':
                this.setState({
                    openDeactivateModal: true,
                    workingResource: resource,
                    resourceOperation: action
                });
                break;
            case 'activate':
                const instructor = {
                    id: resource.id,
                    deleted_at: null
                };

                this.resourceActions.updateResource(instructor, this.sendOptions);
                break;
        }
    },

    /**
     * Fire the deactivate user action
     */
    deactivateUser: function () {
        this.resourceActions.deactivateResource(this.state.workingResource, this.sendOptions);
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openDeactivateModal: false,
            workingResource: {} // Reset working resource
        });
    },

    /**
     * Map instructor object properties to table columns
     */
    tableKeys: {
        "ID": "id",
        "Instructor Order": "order_wheel",
        "Name": "name",
        "Sex": "gender",
        "Admin Level": "user.groups"
    },

    render: function () {
        // Set up table options
        const tableOptions = {
            actionableRows: true,
            actions: ['edit:primary', 'deactivate:danger'],
            actionsCallback: this.handleAction,
            sortable: ['id', 'name', 'order_wheel'],
            mutators: {
                gender: function (value) {
                    return value === 0 ? 'Male' : value === 1 ? 'Female' : 'Other';
                },
                'user.groups': function (groups) {
                    groups = groups || [];

                    return groups.map(function (group) {
                        const groupName = group.id;
                        return groupName.slice(0, 1).toUpperCase() + groupName.slice(1);
                    }).join(', ');
                }
            }
        };

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="8">
                            <h1 className="page-header">Accounts: Instructors</h1>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['name', 'biography', 'user.name', 'user.username']}/>
                            </div>
                        </Column>

                    </Row>

                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Instructors'} options={tableOptions}/>

                            <Paginator actionMethod={this.requestTableData}/>

                            <PerPageSelector actionMethod={this.requestTableData}/>
                        </Column>
                    </Row>
                </div>

                <AddAction createResource={this.handleAction}/>

                <Modal openWhen={this.state.openDeactivateModal}
                       title="Deactivate?" closeText="Close"
                       saveText="Deactivate" afterClose={this.closeModal}
                       beforeSave={this.deactivateUser}
                       afterSave={this.closeModal}>
                    <p>You’re about to deactivate an instructor. In order to reactivate
                        their account, you will have to do
                        so through the 'Activate' button in the actions column.</p>
                    <p>Continue with deactivating this instructor&#63;</p>
                </Modal>
            </div>
        )
    },
});

module.exports = InstructorsPage;
